import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { LocalStorageHandler } from "@saleor/sdk/lib/helpers/LocalStorageHandler";

/**
 * Keeps Saleor SDK payment state in sync after checkoutPaymentCreate
 * flows that bypass useCheckout().createPayment (e.g. manual transfer multipart).
 */
export var syncSdkCheckoutPayment = function syncSdkCheckoutPayment(saleor, input) {
  var _jobsManager;

  var localStorageHandler = (_jobsManager = saleor.checkout.jobsManager) === null || _jobsManager === void 0 ? void 0 : _jobsManager.localStorageHandler;

  if (!localStorageHandler) {
    return false;
  }

  var storedPayment = LocalStorageHandler.getPayment();
  var currentPayment = storedPayment != null ? storedPayment : {};

  var nextPayment = _objectSpread(_objectSpread({}, currentPayment), {}, {
    id: input.id,
    gateway: input.gateway,
    token: input.token != null ? input.token : currentPayment.token
  });

  if (input.total != null) {
    nextPayment.total = input.total;
  }

  if (input.clearCreditCard) {
    delete nextPayment.creditCard;
  }

  localStorageHandler.setPayment(nextPayment);
  return true;
};